import React from 'react';

import { Section, Grid } from '@gogame/components';
import { FormField } from '@gogame/form';

import { loadOwners } from 'scenes/CustomAudiences/Audiences/sources/fields';
import {
  useCanEdit,
  useCanEditAll,
  EDIT_GRANULARITY_OWNER,
} from 'scenes/CustomAudiences/EditGranularityContext';

import { NAME, OWNER } from './constants';

const FieldSet = () => {
  const canEditAll = useCanEditAll();
  const ownerEditAll = useCanEdit(EDIT_GRANULARITY_OWNER);
  return (
    <Section title={'General'}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <FormField.TextField
            label={'Name'}
            required={true}
            padding={0}
            name={NAME}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.Select
            label={'Owner'}
            padding={0}
            name={OWNER}
            disabled={!ownerEditAll}
            source={loadOwners}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default FieldSet;
